// Central content + curated imagery for DV Mart — neighbourhood supermarket, Dabok, Udaipur

export const IMAGES = {
  storefront: "https://customer-assets-agu9un31.emergentagent.net/job_landing-page-223/artifacts/s53m5a0y_unnamed.webp",
  heroMain: "https://images.unsplash.com/photo-1601599561096-f87c95fff1e9?auto=format&fit=crop&w=1100&q=80",
  heroAccent: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1000&q=80",
  produce: "https://images.unsplash.com/photo-1579113800032-c38bd7635818?auto=format&fit=crop&w=1200&q=80",
  aisle: "https://images.unsplash.com/photo-1534723452862-4c874018d66d?auto=format&fit=crop&w=1200&q=80",
  drinks: "https://images.unsplash.com/photo-1601599561213-832382fd07ba?auto=format&fit=crop&w=1100&q=80",
  delivery: "https://images.unsplash.com/photo-1588964895597-cfccd6e2dbf9?auto=format&fit=crop&w=1100&q=80",
  paperBag: "https://images.unsplash.com/photo-1600728619239-d2a73f7aa541?auto=format&fit=crop&w=1100&q=80",
  storeText: "https://images.unsplash.com/photo-1601600576337-c1d8a0d1373c?auto=format&fit=crop&w=1200&q=80",
};

export const BRAND = {
  name: "DV Mart",
  logo: "/dvmart-logo.svg",
  tagline: "Your neighbourhood store, done right.",
  address:
    "Shop No. 5–6, MDR Market, near Jodhpur Mistan Bhandar & Mahaveer Electronics, Dabok Chauraha, Dabok, Udaipur, Rajasthan 313022",
  hours: "Open daily · 6:00 AM – 10:00 PM",
  rating: "4.6",
  reviews: "88",
  established: "1984",
  locality: "Dabok · Udaipur",
  payments: ["Cash", "Credit / Debit Cards", "Google Pay", "NFC / UPI"],
  playStore: "https://play.google.com/store/apps/details?id=com.dvmartinsta",
  mapQuery: "DV Mart Super Market, Dabok Chauraha, Dabok, Udaipur, Rajasthan 313022",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=DV+Mart+Super+Market%2C+Dabok+Chauraha%2C+Dabok%2C+Udaipur%2C+Rajasthan+313022",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "What We Stock", href: "#services" },
  { label: "Our Team", href: "#team" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Visit", href: "#contact" },
];

export const MARQUEE_ITEMS = [
  "Daily Groceries",
  "Fresh Produce",
  "Home Delivery",
  "Everyday Low Prices",
  "Open 6AM–10PM",
  "Rated 4.6 ★",
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Everything your kitchen needs, close to home.",
    body:
      "DV Mart is the go-to store for families around Dabok Chauraha. From your morning milk to the month's ration, we keep the aisles stocked so you never have to travel far.",
  },
  {
    no: "02",
    title: "Fair prices, fresh stock, familiar faces.",
    body:
      "We restock daily and price honestly. Our regulars know us by name — and we know exactly which brand of atta and which chai they came in for.",
  },
  {
    no: "03",
    title: "Can't step out? We'll bring it over.",
    body:
      "Call in your list and our local home-delivery brings the bags to your door across Dabok. Convenience without the queue.",
  },
];

export const SERVICES = [
  {
    tag: "Everyday",
    title: "Daily Groceries",
    desc: "Atta, rice, pulses, cooking oil, spices and all your kitchen staples.",
    image: IMAGES.aisle,
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    tag: "Fresh",
    title: "Fruits & Vegetables",
    desc: "Farm-fresh produce restocked every morning.",
    image: IMAGES.produce,
    span: "lg:col-span-5",
  },
  {
    tag: "Chilled",
    title: "Dairy & Beverages",
    desc: "Milk, curd, paneer, soft drinks, juices and packaged snacks.",
    image: IMAGES.drinks,
    span: "lg:col-span-5",
  },
  {
    tag: "Care",
    title: "Personal Care & Household",
    desc: "Creams, face wash, grooming and everyday cleaning essentials.",
    image: IMAGES.storeText,
    span: "lg:col-span-5",
  },
  {
    tag: "Convenience",
    title: "Local Home Delivery",
    desc: "Call your list in and we deliver the bags to your doorstep across Dabok.",
    image: IMAGES.delivery,
    span: "lg:col-span-7",
  },
];

export const TEAM = [
  {
    name: "Pankaj Agrawal",
    role: "Owner",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_landing-page-223/artifacts/sc7eftlf_WhatsApp%20Image%202026-08-06%20at%2012.39.23%20PM.jpeg",
  },
  {
    name: "Bhavesh Dangi",
    role: "Stock & Purchase",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_landing-page-223/artifacts/ptr1rtnc_image1.jpg",
  },
  {
    name: "Bharat Meghwal",
    role: "Billing & Customer Care",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_landing-page-223/artifacts/jt1a2xo9_WhatsApp%20Image%202026-08-06%20at%2012.29.39%20PM.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "My one-stop shop in Dabok. They always have what I need and the home delivery is a lifesaver on busy days.",
    name: "Rakesh S.",
    detail: "Regular customer, Dabok",
  },
  {
    quote:
      "Fresh vegetables every morning and very fair prices. The staff is friendly and helpful.",
    name: "Anita P.",
    detail: "Local resident, Udaipur",
  },
  {
    quote:
      "Open early till late, so I can pick up groceries whenever I get time. Rated 4.6 for good reason.",
    name: "Mohit J.",
    detail: "Verified review",
  },
];

export const STATS = [
  { value: "4.6★", label: "From 88+ customer reviews" },
  { value: "16 hrs", label: "Open every single day" },
  { value: "5000+", label: "Products on the shelf" },
  { value: "Free*", label: "Local home delivery" },
];
